import { useEffect, useState } from 'react'

// Живой тик от startedAt. Значение выводится из now-состояния (не из прямого
// Date.now() в рендере) — иначе React Compiler мемоизирует его как неизменное по
// startedAt и таймер замерзает. Интервал двигает now раз в секунду.
export function useLiveSeconds(startedAt: string | null | undefined): number {
  const [now, setNow] = useState(() => Date.now())

  useEffect(() => {
    if (!startedAt) return
    const id = setInterval(() => setNow(Date.now()), 1000)
    return () => clearInterval(id)
  }, [startedAt])

  if (!startedAt) return 0
  return Math.max(0, Math.floor((now - new Date(startedAt).getTime()) / 1000))
}
